import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import FormLauncher from '../../../cmn/docAutomation/FormLauncher';
import useViewSwitcher from '../../../../library/hooks/switch/useViewSwitcher';
import SarasTabsSwitch from '../../../../library/repeater/tabs/SarasTabsSwitch';
import SarasViewSwitch from '../../../../library/hooks/switch/SarasViewSwitch';
import { UiForm } from "../../../../library/layout/Index";

const ItemQV = (props) => {
    const { viewMap, viewData, viewSwitcher, ...restProps } = props;
    const rmViewSwitcher = useViewSwitcher("sih");

    // console.log("debug 1", viewData);

    if(!viewData) return null;

    const issueGroups = [
        { key: "sih", val: "SIH", isDefault: 1},
        { key: "purchase", val: "Purchase History"},
        { key: "sales", val: "Sales History"}
    ]

    return (
        <div className='uiPopupItem' style={{backgroundColor:"#ffffff"}}>
            <UiForm formName="itemQVHeader">
                <FormLauncher viewMap={viewMap} viewSwitcher={viewSwitcher} compositionKey="itemQVHeader" 
                viewData={viewData} {...restProps}></FormLauncher>
            </UiForm>

            <SarasTabsSwitch viewSwitcher={rmViewSwitcher} switches={issueGroups} hotKeyPrefix="ctrl"/>
            <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='purchase' hideMode='soft' >
                <UiForm formName="itemQVPurchase">
                    <FormLauncher viewMap={viewMap} viewSwitcher={viewSwitcher} compositionKey="itemQVPurchase" 
                    viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
            </SarasViewSwitch>

            <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='sales' hideMode='soft' >
                <UiForm formName="itemQVSales">
                    <FormLauncher viewMap={viewMap} viewSwitcher={viewSwitcher} compositionKey="itemQVSales" 
                    viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
            </SarasViewSwitch>
            
            <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='sih' hideMode='soft' >
                <UiForm formName="itemQVSIH">
                    <FormLauncher viewMap={viewMap} viewSwitcher={viewSwitcher} compositionKey="itemQVSIH" 
                    viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
            </SarasViewSwitch>
        </div>
    )
}

export default withView(ItemQV, "", "");
